module.exports = __webpack_public_path__ + "img/Rehabilitering.30a3f67a.jpg";